import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectsStyleByRecord } from 'PDF/helpers/documentStyle';
import { IMissionData } from 'PDF/pages/AboutTheCompany/types';
interface IMissionAndVisionRowProps {
  item: IMissionData;
  rowStyles?: { [key: string]: string };
}

const colorIndexes = {
  green: [12, 7, 16],
  blue: [5, 0, 6],
  red: [5, 0, 6],
  blueGreen: [5, 0, 8],
  blueRed: [1, 10, 18],
  blueYellow: [5, 3, 6],
};

export const MissionAndVisionRow: FC<IMissionAndVisionRowProps> = ({ item, rowStyles }) => {
  const { i18n } = useTranslation();
  const [missionColor, visionColor, valuesColor] = getColorObjectsStyleByRecord(colorIndexes, [
    'backgroundColor',
    'backgroundColor',
    'backgroundColor',
    'backgroundColor',
  ]);

  if (!item) {
    return null;
  }

  return (
    <View style={{ ...styles.row, ...rowStyles }} wrap={false}>
      <View
        style={[
          styles.iconWrapper,
          item.type === 'Vision' || item.type === 'Vision Statement' || item.type === 'Бачення компанії'
            ? visionColor
            : item.type === 'Unternehmenswerte' || item.type === 'Company Values' || item.type === 'Цінності компанії'
              ? valuesColor
              : missionColor,
          { width: i18n.language === 'de' ? '140px' : '90px' },
        ]}
      >
        <Image src={item.iconSrc} style={styles.icon} />
        <Text style={[styles.iconText, { color: item.iconTextColor }]}>{item?.type}</Text>
      </View>
      <View style={styles.textWrapper}>
        <Text style={styles.text}>{item.data.replace(/\r?\n|\r/g, '')}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '90px',
  },
  iconWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flexWrap: 'wrap',
  },
  iconText: {
    color: '#FFFFFF',
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: '10px',
    width: '100%',
    marginTop: '4px',
  },
  icon: {
    width: 'auto',
    height: 'auto',
    maxHeight: '19.52px',
    maxWidth: '19.9px',
    marginBottom: '5px',
  },
  textWrapper: {
    backgroundColor: '#fff',
    padding: '22px 21px 22px 13px',
    display: 'flex',
    width: '100%',
  },
  text: {
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: '9px',
    color: '#212121',
    maxWidth: '362px',
  },
});
